import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function PhoneLogin({ onSuccess }) {
  const { acceptSession } = useAuth();
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      if (!sent) {
        await api.post("/auth/phone/start", { phone });
        setSent(true);
        toast.success("Code sent by text");
      } else {
        const { data } = await api.post("/auth/phone/verify", { phone, code });
        acceptSession(data);
        toast.success("Welcome back");
        onSuccess();
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || "Sign in failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-4">
      <div>
        <Label htmlFor="phone" className="font-mono-label">Mobile number</Label>
        <Input id="phone" data-testid="phone-login-number" required value={phone} disabled={sent} onChange={(e) => setPhone(e.target.value)}
          placeholder="+14155552671" className="rounded-sm mt-1.5 h-11" />
      </div>
      {sent && (
        <div>
          <Label htmlFor="code" className="font-mono-label">Code from the text</Label>
          <Input id="code" data-testid="phone-login-code" required value={code} onChange={(e) => setCode(e.target.value)} className="rounded-sm mt-1.5 h-11" />
        </div>
      )}
      <Button type="submit" data-testid="phone-login-submit" disabled={busy} className="w-full h-11 bg-foreground text-background hover:bg-primary rounded-sm btn-invert">
        {busy ? "Please wait…" : sent ? "Sign in →" : "Text me a code →"}
      </Button>
      <p className="text-xs text-muted-foreground">Works for accounts that have added a phone number in Settings.</p>
    </form>
  );
}
